import { SuperSentInvoiceListItem } from '@models';
import { IApiRequest, IApiResponse } from '../../interfaces';

export interface ISentInvoicesState {
  response: IApiResponse<SuperSentInvoiceListItem[]> | null;
  isLoading: boolean;
  error: any;
  lastApiRequest: IApiRequest | null;
}

export const initialState: ISentInvoicesState = {
  response: null,
  isLoading: false,
  error: null,
  lastApiRequest: null,
};
